import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { GAMETYPES, TRANSACTIONTYPES } from "src/app/shared/constants/constants";
import { TransactionHistory } from "src/app/shared/constants/divisional.interface";
import { properties } from 'src/environments/properties';
import { GameService } from "../../../../shared/services/game/game.service";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-token-activity',
    templateUrl: './token-activity.component.html'
})
export class TokenActivityComponent implements OnInit {

    public noActivityMessage: string = '';
    public noActivityAdditionalMessage: string = '';
    public showGrid = false;
    public loading: boolean = false;
    public itemsVisible: number = 3;
    public displayCount: number = 3;
    public tokenActivity:TransactionHistory[] = [];
    public userOptedIn: boolean = false;
    public gameType: string = null;
    public GAMETYPES = GAMETYPES;
    public TRANSACTIONTYPES = TRANSACTIONTYPES;
    public tokenLabelSingular: string = '';
    public tokenLabelPlural: string = '';
    public disclaimerText: string = properties.disclaimerText;
    private destroy$ = new Subject<void>();
    private aaisIntegrationEnabled = false;
    public ariaLabelForToken: string;
    @Input()
    public gameId: string = "";
    @Input()
    public userInfo: any;

    constructor(private elementRef: ElementRef, private gameService: GameService) {
        this.itemsVisible = 3;
        this.displayCount = this.itemsVisible;
        this.noActivityMessage =  properties.nothingHereYet;
        this.noActivityAdditionalMessage =  properties.shopToEarn;
    }

    ngOnInit(): void {

        this.gameService.refreshGameDetailsObservable.pipe(takeUntil(this.destroy$)).subscribe(details => {
            // Game is loaded
            // console.warn("refreshing token activity list for:" + details.codes);
            this.userOptedIn = details.userOptedIn;
            this.gameType = details.type;
            this.tokenLabelSingular = details.tokenLabelSingular;
            this.tokenLabelPlural = details.tokenLabelPlural;
            this.aaisIntegrationEnabled = details.aaisIntegrationEnabled;
            this.ariaLabelForToken = this.getTitle();
            if (details.codes == this.gameId && this.gameService.isAuthenticated(this.userInfo)) {
                this.loading = true;
                // call API
                if (this.gameType == GAMETYPES.EPISODIC) {
                    this.getGameActivityHandler();
                } else {
                    if(this.aaisIntegrationEnabled) {
                        this.getGameActivityHandler();
                    } else {
                        this.gameService.getTokenActivity(this.gameId, false, this.userInfo).subscribe(response => {
                            let program = response.programs.filter(program => program.programCode == this.gameId);
                            if (program && program[0] && program[0].history && program[0].history.length > 0) {
                                this.tokenActivity = program[0].history;
                            }
                            this.loading = false;
                            this.showGrid = true;
                        }, error => {
                            this.loading = false;
                            this.showGrid = true;
                        });
                    }
                    
                }
            } else {
                this.showGrid = true;
            }
        })

        this.gameService.prizeRedeemedObservable.subscribe(flag => {
            if(this.aaisIntegrationEnabled) { 
                this.getGameActivityHandler();
            } else {
                this.gameService.getTokenActivity(this.gameId, true, this.userInfo).subscribe(response => {
                    let program = response.programs.filter(program => program.programCode == this.gameId);
                    if (program && program[0] && program[0].history && program[0].history.length > 0) {
                        this.tokenActivity = program[0].history;
                    }
                    this.loading = false;
                    this.showGrid = true;
                }, error => {
                    this.loading = false;
                    this.showGrid = true;
                })
            }

        });
    }
    public getGameActivityHandler() {
        this.gameService.getGameActivity(this.gameId, this.userInfo).subscribe(response => {
            if (response && response.programs) {
                let program = response.programs.filter(program => program.programCode == this.gameId);
                if (program && program[0] && program[0].history && program[0].history.length > 0) {
                    this.tokenActivity = program[0].history;
                }
            }
            this.loading = false;
            this.showGrid = true;
        }, error => {
            this.loading = false;
            this.showGrid = true;
        });
    }
    public getReadableDate(activity: TransactionHistory): string {
        const date = this.getDisplayDate(activity);
        if (!date) return '';
        return date.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
    }


    public getDisplayDate(activity: TransactionHistory): Date {
        let displayDate: Date = null; 
        if (activity && activity.transactionTs && activity.transactionTs != '') {
            let ts = activity.transactionTs; 
            displayDate = new Date(ts.split('[')[0]);
        }
        return displayDate;
    }

    public showMore(): void {
        this.displayCount += this.itemsVisible;
        if (window['AB'] && window['AB'].DATALAYER) {
            window['AB'].DATALAYER.setLinkClickEvents(`games|${this.gameId}:token-activity`);
        }
        this.ariaLabelForToken = `${this.getTitle()} loaded few more token activities`;
        setTimeout(() => {
            const newActivityElement = this.elementRef.nativeElement.querySelector('#newActivity');
            if (newActivityElement) {
                newActivityElement.setAttribute('tabindex', '-1');
                newActivityElement.focus();
            }
        }, 0);

    }

    public tokenLabel(points: number, transactionType: string) {
        if (this.gameType == GAMETYPES.EPISODIC) {
            if(transactionType != TRANSACTIONTYPES.SWEEPSTAKES){
                if (Math.abs(points) == 1) {
                    return points + ' Gameplay';
                } else {
                    return points + ' Gameplays';
                }
            } else {
                if (Math.abs(points) == 1) {
                    return points + ' Sweepstake';
                } else {
                    return points + ' Sweepstakes';
                }
            }
            
        } else {
            if (Math.abs(points) == 1) {
                return points + ' ' + this.tokenLabelSingular;
            } else {
                return points + ' ' + this.tokenLabelPlural;
            }
        }
    }

    public getTitle() {
        let title = this.tokenLabelSingular + ' Activity';

        if (this.gameType == GAMETYPES.EPISODIC) {
            title = 'Game Activity';
        } 
        
        return title; 
    }

    ngOnDestroy() {
        this.destroy$.next();  // This will trigger the unsubscription
        this.destroy$.complete();
      }
}
